import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-forecast-master-card',
    templateUrl: './forecast-master-card.component.html',
    styleUrl: './forecast-master-card.component.scss',
    standalone: false
})
export class ForecastMasterCardComponent {
  @Input() masterData;
  @Input() currentYear;
  @Input() dataSource;
  CY_Rate_Unit: any;
  PY_Rate_Unit: any;
  FY_Rate_Unit: any;

  ngOnInit() {
    this.segMasterData(this.dataSource, this.currentYear);
  }

  ngOnChanges() {
    this.segMasterData(this.dataSource, this.currentYear);
  }

  segMasterData(data, yr) {
    if (data?.current) {
      this.CY_Rate_Unit = data.current[yr] ? data.current[yr] : { CY_Rate: 0, Unit_Of_Measure: '' };
      this.PY_Rate_Unit = data.current[yr - 1] ? data.current[yr - 1] : { CY_Rate: 0, Unit_Of_Measure: '' };
      this.FY_Rate_Unit = data.current[yr + 1] ? data.current[yr + 1] : { CY_Rate: 0, Unit_Of_Measure: '' };
    } else {
      this.CY_Rate_Unit = { CY_Rate: 0, Unit_Of_Measure: '' };
      this.PY_Rate_Unit = { CY_Rate: 0, Unit_Of_Measure: '' };
      this.FY_Rate_Unit = { CY_Rate: 0, Unit_Of_Measure: '' };
    }
  }

}
